var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#282D2D",
    d: "m15.828 5.14-.937.938a.583.583 0 0 0 .046.797l3.75 3.61H2.563a.57.57 0 0 0-.562.562v1.312c0 .329.234.563.563.563h16.125l-3.75 3.656a.583.583 0 0 0-.047.797l.937.938a.635.635 0 0 0 .797 0l6.188-6.188a.635.635 0 0 0 0-.797l-6.188-6.187a.635.635 0 0 0-.797 0"
  })));
};
export default SvgArrowRight;